import React from 'react';

import { SeasonalGuideSectionArticles } from './SeasonalGuideSectionArticles';
import { SeasonalGuideSectionBannerBasic } from './SeasonalGuideSectionBannerBasic';
import { SeasonalGuideSectionBannerRVRentals } from './SeasonalGuideSectionBannerRVRentals';
import { SeasonalGuideSectionHeading } from './SeasonalGuideSectionHeading';
import { SeasonalGuideSectionReadingList } from './SeasonalGuideSectionReadingList';
import { SeasonalGuideSectionSocialContent } from './SeasonalGuideSectionSocialContent';
import { TSeasonalGuideSection } from './types';

type TSeasonalGuideSectionProps = TSeasonalGuideSection;

export const SeasonalGuideSection = ({
  id,
  tag,
  heading,
  articles,
  readingList,
  banners,
  socialContent,
}: TSeasonalGuideSectionProps) => {
  return (
    <div id={id} data-seasonal-guide-section>
      <SeasonalGuideSectionHeading tag={tag} {...heading} />

      <div className="flex flex-col py-8 md:py-10 lg:py-12 gap-y-8 md:gap-y-12 lg:gap-y-16">
        <SeasonalGuideSectionArticles headingAlign={heading.imagePosition} articles={articles} />
        <SeasonalGuideSectionReadingList readingList={readingList} />
        {socialContent && <SeasonalGuideSectionSocialContent socialContent={socialContent} />}
        {banners?.map((banner, index) => {
          if (banner.type === 'RVRentals') {
            return <SeasonalGuideSectionBannerRVRentals key={index} {...banner} />;
          }

          if (banner.type === 'Basic') {
            return <SeasonalGuideSectionBannerBasic key={index} {...banner} />;
          }

          return null;
        })}
      </div>
    </div>
  );
};
